import React, { Suspense } from "react";

// Always OnScreen
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";

// All Routes
import AllRoutes from "./AllRoutes";

// Loading Screens
import Loading from "../components/layout/Loading";
import { AuthProvider } from "../auth/AuthContext";

function MainApp() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <AuthProvider>
        <Navbar />
        <div className="flex-grow-1">
          <Suspense fallback={<Loading />}>
            <AllRoutes />
          </Suspense>
        </div>
        <Footer />
      </AuthProvider>
    </div>
  );
}

export default MainApp;
